import { ExportsPageAction, ExportsPageState } from './interfaces';

export const initialState: ExportsPageState = {
  crud: { open: false, record: null, entityType: null, mode: null },
  deleteModal: { open: false, record: null },
};

export function reducer(prevState: ExportsPageState, action: ExportsPageAction): ExportsPageState {
  switch (action.type) {
    case 'openCrud':
      if (!action.mode || !action.entityType) throw new Error(`Invalid action provided ${action}`);
      return {
        ...initialState,
        crud: { open: true, record: action.record ?? null, entityType: action.entityType, mode: action.mode },
      };
    case 'closeCrud':
      return {
        ...initialState,
      };
    case 'openDeleteModal':
      if (!action.record) throw new Error(`Invalid action provided ${action.type}`);
      return {
        ...prevState,
        deleteModal: {
          open: true,
          record: action.record,
        },
      };
    case 'closeDeleteModal':
      return {
        ...prevState,
        deleteModal: {
          open: false,
          record: null,
        },
      };
    default:
      throw new Error('No action provided');
  }
}
